export const FETCH_FAVORITES_REQUEST = 'FETCH_FAVORITES_REQUEST'
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS'
export const FETCH_FAVORITES_FAILURE = 'FETCH_FAVORITES_FAILURE'

export const FETCH_DISLIKES_REQUEST = 'FETCH_DISLIKES_REQUEST'
export const FETCH_DISLIKES_SUCCESS = 'FETCH_DISLIKES_SUCCESS'
export const FETCH_DISLIKES_FAILURE = 'FETCH_DISLIKES_FAILURE'

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'

export const CLEAR_RIGHT_SWIPES_REQUEST = 'favorites/CLEAR_RIGHT_SWIPES_REQUEST'
export const CLEAR_RIGHT_SWIPES_SUCCESS = 'favorites/CLEAR_RIGHT_SWIPES_SUCCESS'
export const CLEAR_RIGHT_SWIPES_FAILURE = 'favorites/CLEAR_RIGHT_SWIPES_FAILURE'

export const CLEAR_LEFT_SWIPES_REQUEST = 'favorites/CLEAR_LEFT_SWIPES_REQUEST'
export const CLEAR_LEFT_SWIPES_SUCCESS = 'favorites/CLEAR_LEFT_SWIPES_SUCCESS'
export const CLEAR_LEFT_SWIPES_FAILURE = 'favorites/CLEAR_LEFT_SWIPES_FAILURE'
